import { render, staticRenderFns } from "./posterModal.vue?vue&type=template&id=dccc4948&"
import script from "./posterModal.vue?vue&type=script&lang=js&"
export * from "./posterModal.vue?vue&type=script&lang=js&"
import style0 from "./posterModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports